import { Button } from '@simplywallst/ui-core';
import { useCreateNotesSidebar } from '../../../hooks/useCreateNotesSidebar';

interface Props {
  companyId?: string;
  uniqueSymbol?: string;
  trackEvent: (event: { action: string; modifier: string }) => void;
}

const SeeMoreButton = ({ companyId, uniqueSymbol, trackEvent }: Props) => {
  const { openSidebar, isSidebarShowing } = useCreateNotesSidebar({
    companyId,
    uniqueSymbol,
  });

  return (
    <Button
      data-cy-id="my-notes-see-more"
      disabled={isSidebarShowing}
      display="block"
      onClick={() => {
        openSidebar();
        trackEvent({
          action: 'click',
          modifier: 'see-more',
        });
      }}
      styleType="loud"
    >
      See more
    </Button>
  );
};

export default SeeMoreButton;
